import {
  Module,
  Mutation,
  MutationAction,
  VuexModule,
} from "vuex-module-decorators";
import ActivityDefinition from "@/app/models/activity/activity-definition.model";
import ActivityDefinitionModel from "@/app/models/activity/activity-definition.model";
import ActivityModel from "@/app/models/activity/activity.model";
import { activityServicev2 } from "@/app/services/activity.service";
import { ActivitySecurity } from "@/app/models/activity/security.model";
import store from "@/store";
import axios from "axios";
import { authenticationService } from "@/services/authentication.service";
import analyticsService from "@/services/analytics.service";
import router from "@/router";
import IamRole from "@/contracts/iam/IamRole";

@Module
export default class ActivityModule extends VuexModule {
  currentActivityDefinition: ActivityDefinitionModel = {
    id: "",
    version: "",
    name: "",
    dashboard: { definitionId: "" },
    roles: {},
    products: {
      rules: {},
      overviewDefinitionId: "",
      createProductDialogDefinitionId: "",
      updateProductDialogDefinitionId: "",
      manufacturers: [],
      materialTypes: [],
    },
    planning: {
      overviewDefinitionId: "",
      updatePlanningDialogDefinitionId: "",
    },
    checkins: {
      overviewDefinitionId: "",
      completeCheckinDialogDefinitionId: "",
      createCheckinDialogDefinitionId: "",
      uploadFilesCheckinDialogDefinitionId: "",
      detailsCheckinDialogDefinitionId: "",
      regardingType: "",
      canCreateNew: "false",
      linkPath: '',
      linkName: '',
      referenceType: ''
    },
    dossiers: {
      overviewDefinitionId: "",
      entries: [],
    },
    generalDocuments: {
      overviewDefinitionId: "",
      detailsDocumentDialogDefinitionId: "",
      modifyDocumentDialogDefinitionId: "",
      uploadDocumentDialogDefinitionId: "",
      shareDialogDefinition: "",
      sharing: [],
      sharingScopes: {
        fullAccess: []
      },
      entries: [],
      rules: {}
    },
    security: {
      dossiers: [],
      tabs: {},
      home: {},
    },
    activityData: {},
    maintenance: {
      title: '',
      startTime: new Date(new Date().getTime() - 60000),
      endTime: new Date(new Date().getTime() - 50000),
      messageTitle: '',
      message:'',
      type: 'construction'
    }
  };
  eligibleActivities: ActivityModel[] = [];
  currentActivity: ActivityModel = { id: "", name: "nan" };
  currentActivitySecurity: ActivitySecurity = {
    dossiers: {},
    tabs: {},
    home: {},
  };

  @Mutation
  setCurrentActivityDefinition(activity: ActivityDefinition): void {
    // analyticsService.setUserActivity(activity);
    this.currentActivityDefinition = activity;
  }

  @Mutation
  setEligibleActivities(activities: ActivityModel[]): void {
    this.eligibleActivities = activities;
  }
  @MutationAction({
    mutate: [
      "currentActivity",
      "currentActivityDefinition",
      "currentActivitySecurity",
    ],
  })
  async setCurrentActivity(activity: ActivityModel) {
    analyticsService.setUserActivity(activity.name);
    localStorage.setItem("currentActivity", activity.id);
    authenticationService.setAxiosActivityHeader();

    const activityDefinition = await activityServicev2.getActivityDefinition(      activity.id, false    );

    const security: ActivitySecurity = {
      dossiers: {},
      tabs: {},
      home: {},
    };

    const roleIds: string[] = store.state.user.roles.filter(role => activity.id === role.activityId).map((role) => role.id);

    if (activityDefinition?.security?.dossiers) {
      activityDefinition.security.dossiers.forEach((securityByRoles) => {
        const other: { [key: string]: boolean } = {};
        if (securityByRoles.other) {
          Object.keys(securityByRoles.other).forEach((key) => {
            other[key] = securityByRoles.other[key].some((v) =>
              roleIds.includes(v)
            );
          });
        }

        security.dossiers[securityByRoles.dossierDefinitionId] = {
          dossierDefinitionId: securityByRoles.dossierDefinitionId,
          create: securityByRoles.create.some((v) => roleIds.includes(v)),
          edit: securityByRoles.edit.some((v) => roleIds.includes(v)),
          read: securityByRoles.read.some((v) => roleIds.includes(v)),
          list: securityByRoles.list.some((v) => roleIds.includes(v)),
          other: other,
          singleDossier: securityByRoles.singleDossier.some((v) =>
            roleIds.includes(v)
          ),
        };
      });
    }

    const tabSecurity = {};
    if (activityDefinition?.security?.tabs) {
      Object.entries(activityDefinition.security.tabs).forEach((entry) => {
        tabSecurity[entry[0]] =
          entry[1].some((v) => roleIds.includes(v)) || false;
      });
    }

    security.tabs = tabSecurity;
    security.home = activityDefinition?.security?.home;

    if(activity){
      const currentUserRoles: IamRole[] = store.state.user.roles;
      if(currentUserRoles){
        store.commit("setActivityRoles", currentUserRoles.filter(value => activity.id === value.activityId));
      }else{
        store.commit("setActivityRoles", []);
      }
    }else{
      store.commit("setActivityRoles", []);
    }

    return {
      currentActivity: activity,
      currentActivityDefinition: activityDefinition,
      currentActivitySecurity: security,
    };
  }
}
